import { ShiftManagementLedEmployeesByCurrentDocument } from 'generated/resources/graphql'
import compact from 'lodash/compact'
import uniq from 'lodash/uniq'

import { useQuery } from 'modules/core/hooks/useQuery'

export const useLedEmployeesByCurrent = ({ skip }: { skip: boolean }) => {
  const { loading, data } = useQuery(ShiftManagementLedEmployeesByCurrentDocument, {
    fetchPolicy: 'cache-first',
    skip,
  })

  const current = data && data.apiCore.currentsConnection.edges.at(0)?.node
  const memberships = current?.employee?.memberships || []
  const ledEmployees = memberships.flatMap(({ team }) => team?.employeeNames.map(({ id }) => id))

  return {
    loading,
    ledEmployees: uniq(compact(ledEmployees)) || [],
  }
}
